module.exports = __webpack_public_path__ + "803243b0b238a957d6d7b7fa240f801a.pdf";